/*
 * @Author: lan.h
 * @Date: 2022-04-27 10:06:14
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-10 17:33:36
 * @Description: 数字化营销表单
 */
import { getMeta, digitalMarket } from '@/service'
const contact_mixins = {
  data() {
    return {
      area: [
        {id: '1', name: '产业企业',
        arr: [
          {id: '4', desc: '品牌需求（扩大企业知名度，获得投资机构的关注，加速融资进程，需要线上+线下传播服务）'},
          {id: '5', desc: '产业咨询需求（了解产业趋势，辅助企业决策，需要动脉橙产业智库、咨询报告、特定领域调研、闭门会、专题内训服务）'},
          {id: '6', desc: '对接需求（接触潜在客户，需要创新方向的特定项目遴选、特定机构对接服务）'},
          {id: '7', desc: '产业数据库需求（实时更新的行业知识库，了解赛道要点、公司分布、资本趋势、产品进展、政策发布；追踪查询医疗健康产业领域十万余家企业和机构最新动态）'},
          {id: '13', desc: '人才寻聘需求（医健企业或投资机构被投企业关键人才招聘，需要根据发展阶段拟定人才配置、储备、招募计划，寻聘从经理到CXO的中高端人才或兼职专家顾问）'},
          {id: '14', desc: '园区落地需求（有效益或创新增量溢出或转移，或在选择初创项目启动地，落地于蛋黄科技（动脉网）运营的产业创新中心或合作的有关园区，获得当地产业发展资源和专业技术服务、创新加速服务等，促进企业加速成长）'},
        ]},
        {id: '2', name: '政府及产业运营机构', 
        arr: [
          {id: '4', desc: '品牌需求（扩大产业知名度，吸引产业企业关注，需要产业企业大会组织承办服务）'},
          {id: '8', desc: '招商需求（接触特定领域的项目或企业，需要政企交流会、闭门会、企业调研考察服务）'},
          {id: '9', desc: '引智需求（接触特定领域的研究人员或团队，需要产业科技研讨会、高校科研机构参访服务）'},
          {id: '10', desc: '产业培育需求（确定产业发展方向，培育当地产业企业，需要产业咨询报告、动脉橙产业智库、企业家成长课程、企业合作交流活动服务）'},
          {id: '7', desc: '产业数据库需求（实时更新的行业知识库，了解赛道要点、公司分布、资本趋势、产品进展、政策发布；追踪查询医疗健康产业领域十万余家企业和机构最新动态）'}
        ]},
        {id: '3', name: '金融机构',
        arr: [
          {id: '4', desc: '机构品牌需求（扩大机构知名度，需要线上+线下传播、CEO年会承办服务））'},
          {id: '6', desc: '项目对接需求（接触潜在投资项目，需要赛道研究、优质项目对接服务）'},
          {id: '11', desc: '投后管理需求（项目投后的精细化管理，需要企业家品牌素养培训、产业趋势闭门研讨会、企业发展资源对接服务）'},
          {id: '7', desc: '产业数据库需求（实时更新的行业知识库，了解赛道要点、公司分布、资本趋势、产品进展、政策发布；追踪查询医疗健康产业领域十万余家企业和机构最新动态）'},
        ]},
      ],
      tag_list: [
        {id: '1', name: '产业企业'},
        {id: '2', name: '政府及运营机构'},
        {id: '3', name: '金融机构'},
        {id: '4', name: '品牌需求'},
        {id: '5', name: '产业咨询'},
        {id: '6', name: '项目对接'},
        {id: '7', name: '产业智库'},
        {id: '8', name: '招商需求'},
        {id: '9', name: '引智需求'},
        {id: '10', name: '产业培育'},
        {id: '11', name: '投后管理'},
        {id: '12', name: '其他需求'},
        {id: '13', name: '人才招聘'},
        {id: '14', name: '园区落地'}
      ],
      formItem: {
        name: '',
        phone: '',
        institute: '',
        duties: '',
        province: '',
        otherNeeds: '',
        serviceNeeds: [],
        channelTag: '',
        is_needs: '',
        area: ''   //前端写死
      },
      ruleInline: {
        name: [
          { required: true, message: '请填写您的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写您的电话', trigger: 'blur' }
        ],
        institute: [
          { required: true, message: '请填写您的所在机构', trigger: 'blur' }
        ],
        duties: [
          { required: true, message: '请填写您的职务', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择您所在的省份', trigger: 'change' }
        ],
        is_needs: [
          { required: true, message: '请选择您是否想要了解动脉网提供的服务', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请选择您在行业中的领域', trigger: 'change' }
        ],
      },
      address: [],
      areaIndex: '',
      is_serviceNeeds_tip: false,
      button_loading: false
    }
  },
  methods: {
    areaChange(val) {
      this.areaIndex = this.area.findIndex(item => item.id == val)
      this.formItem.otherNeeds = ''
      this.formItem.serviceNeeds = []
    },
    needsChange() {
      this.formItem.otherNeeds = ''
      this.formItem.serviceNeeds = []
      this.formItem.area = ''
    },
    serviceNeedsChange() {
      this.is_serviceNeeds_tip = false
    },
    handleSubmit() {
      let is_serviceNeeds_valid = true
      if((this.formItem.channelTag != '7' || (this.formItem.channelTag == '7' && this.formItem.is_needs == '1')) && this.formItem.serviceNeeds.length == 0 && !this.formItem.otherNeeds){
        is_serviceNeeds_valid = false
      }
      this.$refs['formcontact'].validate(async(valid) => {
        if (valid && is_serviceNeeds_valid) {
          this.button_loading = true
          if(this.formItem.otherNeeds) {
            this.formItem.serviceNeeds.push('12')
          }
          this.formItem.serviceNeeds.unshift(this.formItem.area)
          let res = await digitalMarket(this.formItem, (error) => {
            this.$message.error('请求错误！')
          })
          if (res.code == 0) {
            this.handleReset()
            this.$Message.success('提交成功!');
            this.button_loading = false
          } else {
            this.$message.error(res.msg)
            this.button_loading = false
          }
        }else{
          if(!is_serviceNeeds_valid){
            this.is_serviceNeeds_tip = true
          }
        }
      })
    },
    handleReset () {
      this.$refs['formcontact'].resetFields();
    },
    /**
     * @description: 栏目元数据
     * @param {*}
     * @return {*}
     */
    async getMeta() {
      let res = await getMeta({
        name: ['addressScreen']
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'address', res.meta.addressScreen)
      } else {
        this.$message.error(res.msg)
      }
    },
  }
}

export { contact_mixins }